<template>
  <div class="stock-line-synced-qty">
    <StockLineField
      v-if="showMeasures"
      :value="line.quantity"
      type="number"
      :hint="kgHint"
      :error="error"
      :disabled="disabled"
      @focus="$emit('focus', $event)"
      @input="onKgInput"
    />
    <StockLineField
      v-if="showMeasures && hasSecondary"
      :value="line.secondary_quantity"
      type="number"
      :hint="secondaryHint"
      :disabled="disabled"
      class="mt-1"
      @focus="$emit('focus', $event)"
      @input="onSecondaryInput"
    />
    <StockLineField
      v-for="level in shownPackagingLevels"
      :key="`pack-level-${level.level}`"
      :value="packagingQuantity(level.level)"
      type="number"
      :hint="packagingHint(level)"
      :disabled="disabled"
      class="mt-1"
      @focus="$emit('focus', $event)"
      @input="onPackagingLevelInput(level.level, $event)"
    />
  </div>
</template>

<script>
import StockLineField from "@/views/partials/stock/StockLineField.vue";
import {
  applyBreakdownToLine,
  packagingLevels as resolvePackagingLevels,
  syncFromChangedField,
  hasSecondaryUnit,
} from "@/common/stock/productPackagingConversion";

export default {
  name: "StockLineSyncedQtyFields",
  components: { StockLineField },
  props: {
    line: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    kgHint: {
      type: String,
      default: "kg",
    },
    showMeasures: {
      type: Boolean,
      default: true,
    },
    showPackaging: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    product() {
      return this.line.stock_product || null;
    },
    hasSecondary() {
      return hasSecondaryUnit(this.product);
    },
    packagingLevels() {
      return resolvePackagingLevels(this.product);
    },
    shownPackagingLevels() {
      if (!this.showPackaging) {
        return [];
      }
      return this.packagingLevels;
    },
    secondaryHint() {
      const code = this.product?.secondary_unit?.code || this.product?.secondary_unit_code || "sec";
      return code;
    },
  },
  methods: {
    packagingQuantity(level) {
      if (!this.line.packaging_quantities) {
        return null;
      }
      return this.line.packaging_quantities[level];
    },
    packagingHint(level) {
      return level.packaging?.label || level.packaging?.name || level.packaging_name || `L${level.level}`;
    },
    ensurePackagingQuantities() {
      if (!this.line.packaging_quantities || typeof this.line.packaging_quantities !== "object") {
        this.$set(this.line, "packaging_quantities", {});
      }
    },
    emitQuantityChanged() {
      this.$emit("quantity-changed", this.line);
    },
    onKgInput(value) {
      const breakdown = syncFromChangedField(this.product, "kg", value);
      this.ensurePackagingQuantities();
      applyBreakdownToLine(this.line, breakdown);
      this.emitQuantityChanged();
    },
    onSecondaryInput(value) {
      const breakdown = syncFromChangedField(this.product, "secondary", value);
      this.ensurePackagingQuantities();
      applyBreakdownToLine(this.line, breakdown);
      this.emitQuantityChanged();
    },
    onPackagingLevelInput(level, value) {
      const breakdown = syncFromChangedField(this.product, level, value);
      this.ensurePackagingQuantities();
      applyBreakdownToLine(this.line, breakdown);
      this.emitQuantityChanged();
    },
  },
};
</script>

<style scoped>
.stock-line-synced-qty {
  min-width: 96px;
}
</style>
